import { hlvCoverNeeded } from "../../engine/calculations";

const hlvConfig = {
  key: "hlv-term-insurance",
  title: "HLV / Term Insurance Need",
  category: "Insurance & Protection",
  description: "Estimate the term insurance cover needed to protect your family's income.",
  fields: [
    { key: "annualIncome", label: "Annual income", type: "currency", default: 12_00_000, min: 1000, max: 10_00_00_000, profileKey: "annualIncome" },
    { key: "supportYears", label: "Years of income to replace", type: "number", default: 15, min: 1, max: 40 },
    { key: "loans", label: "Outstanding loans", type: "currency", default: 20_00_000, min: 0, max: 10_00_00_000 },
    { key: "futureGoalCosts", label: "Future goal costs", type: "currency", default: 0, min: 0, max: 10_00_00_000, optional: true, help: "Big future costs to cover, e.g. children's education (optional)." },
    { key: "existingInvestments", label: "Existing investments", type: "currency", default: 10_00_000, min: 0, max: 10_00_00_000, profileKey: "netWorth" },
    { key: "existingCover", label: "Existing insurance cover", type: "currency", default: 0, min: 0, max: 10_00_00_000 },
  ],
  compute(values) {
    const annualIncome = Number(values.annualIncome) || 0;
    const supportYears = Number(values.supportYears) || 0;
    const loans = Number(values.loans) || 0;
    const futureGoalCosts = Number(values.futureGoalCosts) || 0;
    const existingInvestments = Number(values.existingInvestments) || 0;
    const existingCover = Number(values.existingCover) || 0;

    const coverNeeded = hlvCoverNeeded({
      annualIncome,
      supportYears,
      loans,
      futureGoalCosts,
      existingInvestments,
      existingCover,
    });

    return {
      headline: { label: "Additional cover needed", value: coverNeeded },
      breakdown: [
        { label: "Income to replace", value: annualIncome * supportYears },
        { label: "Loans + future goals", value: loans + futureGoalCosts },
        { label: "Existing investments + cover", value: existingInvestments + existingCover },
      ],
    };
  },
};

export default hlvConfig;
